import React, {FC} from 'react'
import {IAppsModel} from '../../../types/apps/AppsModel'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../template/helpers'

type Props = {
  app: IAppsModel
}

const ListCSRItem: FC<Props> = ({app}) => {
  return (
    <div className='flex-fill text-center bg-hover-light-info rounded my-1'>
      <Link to={`/csr/${app.id}/`}>
        <div className='d-flex flex-row align-items-center flex-nowrap py-4'>
          <div className='badge ms-3 me-2 badge-light-info'>{app.id.slice(0, -30)}...</div>
          <div className='badge badge-light-primary ms-3'>{app.crm === 'ONEC' ? '1C' : app.crm}</div>
          <KTSVG path='/media/icons/duotune/abstract/abs022.svg' className='svg-icon-gray-600 svg-icon-1x ms-3' />
          <div className='badge badge-light-warning ms-3'>{app.pbx}</div>
          <span className='ms-3 text-gray-700'>{app.crm_domain}</span>
        </div>
      </Link>
    </div>
  )
}

export {ListCSRItem}
